import React from "react";

const BasketCircle = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28" cy="28" r="28" fill="#DE5252" fillOpacity="0.09" />
    <g clipPath="url(#clip0_1259_14443)">
      <path d="M41 15H15V41H41V15Z" fill="white" fillOpacity="0.01" />
      <path
        d="M19.875 20.417V38.8337H36.125V20.417H19.875Z"
        stroke="#C76B6B"
        strokeWidth="1.92045"
        strokeLinejoin="round"
      />
      <path
        d="M25.833 25.833V32.8747"
        stroke="#C76B6B"
        strokeWidth="1.92045"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.166 25.833V32.8747"
        stroke="#C76B6B"
        strokeWidth="1.92045"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.167 20.417H38.8337"
        stroke="#C76B6B"
        strokeWidth="1.92045"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.666 20.417L25.4476 17.167H30.5869L32.3327 20.417H23.666Z"
        stroke="#C76B6B"
        strokeWidth="1.92045"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1259_14443">
        <rect width="26" height="26" fill="white" transform="translate(15 15)" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(BasketCircle);
